import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../src/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { ArrowLeft, Eye, EyeOff } from 'lucide-react';
import './LoginUser.css';

function LoginUser() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const navigateToPasswordRecovery = () => {
    navigate('/password-recovery');
  }
  
  const navigateToRegisterUser = () => {
    navigate('/register-user');
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setMessage('Por favor, completa ambos campos.');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const auth = getAuth();
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userDocRef = doc(db, 'Usuarios', user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (!userDocSnap.exists()) {
        setMessage('No se encontró información del usuario.');
        await auth.signOut(); // Cerrar sesión si no hay datos
        return;
      }

      const userData = userDocSnap.data();

      // Redirección basada en el rol del usuario
      switch (userData.rol) {
        case 'admin':
          navigate('/home'); // Redirige a la página de admin
          break;
        case 'usuario':
        case 'vendedor':
          navigate('/page-store'); // Redirige a la tienda
          break;
        default:
          setMessage('Rol de usuario no reconocido.');
          await auth.signOut();
          return;
      }

    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      
      // Manejo específico de errores de Firebase
      let errorMessage = 'Error al iniciar sesión.';
      switch (error.code) {
        case 'auth/user-not-found':
          errorMessage = 'No existe una cuenta con este correo.';
          break;
        case 'auth/wrong-password':
          errorMessage = 'Contraseña incorrecta.';
          break;
        case 'auth/invalid-email':
          errorMessage = 'Formato de correo inválido.';
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Demasiados intentos fallidos. Intenta más tarde.';
          break;
        case 'auth/invalid-credential':
          errorMessage = 'Credenciales inválidas.';
          break;
        default:
          errorMessage = 'Correo o contraseña incorrectos.';
      }
      
      setMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate('/');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Botón de Regresar */}
        <button className="back-button" onClick={handleGoBack}>
          <ArrowLeft size={20} />
          <span>Regresar</span>
        </button>

        <div className="logo-section">
          <img src={logo} alt="Logo de la empresa" className="company-logo" />
          <span>Vive el Entretenimiento Sin Límite</span>
        </div>

        <h1 className="login-title">Inicia Sesión</h1>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-input"
            required
          />

          <div className="password-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-input"
              required
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          {message && <p className="message-text">{message}</p>}

          <button type="submit" disabled={loading} className="submit-button">
            {loading ? 'Ingresando...' : 'Iniciar sesión'}
          </button>
        </form>

        {/* Olvidé mi contraseña */}
        <button
          className="forgot-link"
          onClick={navigateToPasswordRecovery}
        >
          ¿Olvidaste tu contraseña?
        </button>

        {/* Registro */}
        <button
          className="register-link"
          onClick={navigateToRegisterUser}
        >
          ¿No tienes una cuenta? Regístrate
        </button>
      </div>
    </div>
  );
}

export default LoginUser;